import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import AdminPanel from "./pages/AdminPanel";
import TrainerPanel from "./pages/TrainerPanel";
import UserCalendar from "./components/user/UserCalendar";
import ContextProvider from "./context/Context";
import Login from "./components/user/Login";
import UserPanel from "./pages/UserPanel";
import Home from "./pages/Home";
import Navbar from "./components/user/Navbar";
import Footer from "./components/user/Footer";
import Kontatk from "./pages/Kontatk";
import Oferta from "./pages/Oferta";
import Kombinezon from "./pages/Kombinezon";
import FirstVisit from "./components/user/FirstVisit";
import ProtectedRoute from "./components/user/ProtectedRoute";

function AppContent() {
  const location = useLocation();
  const [showLogin, setShowLogin] = useState(false);

  // Define paths where Navbar and Footer should not be displayed
  const noNavbarFooterPaths = ["/admin", "/trainer"];

  // Check if the current path is in the noNavbarFooterPaths array
  const shouldShowNavbarFooter = !noNavbarFooterPaths.includes(
    location.pathname
  );

  return (
    <ContextProvider>
      {shouldShowNavbarFooter && <Navbar setShowLogin={setShowLogin} />}
      {showLogin && <Login setShowLogin={setShowLogin} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setShowLogin={setShowLogin} />} />
        <Route
          path="/userpanel/*"
          element={
            <ProtectedRoute allowedRoles={["user", "trainer", "admin"]}>
              <UserPanel />
            </ProtectedRoute>
          }
        />
        <Route path="/pierwsza-wizyta" element={<FirstVisit />} />
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trainer"
          element={
            <ProtectedRoute allowedRoles={["trainer", "admin"]}>
              <TrainerPanel />
            </ProtectedRoute>
          }
        />
        <Route path="/oferta" element={<Oferta />} />
        <Route path="/kombinezony" element={<Kombinezon />} />
        <Route path="/kontakt" element={<Kontatk />} />
      </Routes>
      {shouldShowNavbarFooter && <Footer />}
    </ContextProvider>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
